import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Attendance } from '../../../../class/attendance';
import { SynergoCitationService } from '../../../../service/synergo-citation/synergo-citation.service';
import { TranslateService } from '@ngx-translate/core';
import { Message, SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { RequisitionService } from '../../../../service/requisition/requisition.service';
import { NotificationsService } from '../../../../../../theme/services/notifications/notifications.service';
import { config } from '../../../../../../../environments/config';
import { UploadFilesService } from '../../../../service/upload-files/upload-files.service';
import { HasPermissionService } from '../../../../service/has-permission/has-permission.service';
import { formatDate } from '../../../../../../theme/functions/formatDate.function';
import { calendarES } from '../../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-synergo-new-citation',
  templateUrl: './synergo-new-citation.component.html',
  styleUrls: ['./synergo-new-citation.component.scss']
})
export class SynergoNewCitationComponent implements OnInit, OnChanges {

    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Attendance;
    @Input() idRequisition: string;
    @Input() idCitation: string;
    @Input() editPart: string;
    @Input() editEventPart: string;
    @Input() minimum: boolean;
    @Input() allinone: boolean;

    messages: Message[] = [];

    public uploadedFileTest: any[] = [];
    public prewiewFileTest: any;
    public promiseFileTest: Promise<any>;

    public apiUrl = config.API_ROOT;
    public msgs: Message[];

    public promiseForm: Promise<any>;
    public form: FormGroup;
    public read: AbstractControl;
    public venue_id: AbstractControl;
    public company_id: AbstractControl;
    public candidate_id: AbstractControl;
    public profile_survey_id: AbstractControl;
    public requisition_observation: AbstractControl;
    public management: AbstractControl;
    // public status: AbstractControl;
    public date_citations: AbstractControl;
    public source: AbstractControl;

    public recruited: AbstractControl;
    public recruited_at: AbstractControl;
    public recruited_by_id: AbstractControl;
    // public elaborated_by_id: AbstractControl;
    public called_by_id: AbstractControl;
    // public time: AbstractControl;
    public observation_citation: AbstractControl;
    public attended: AbstractControl;
    // public arrival_time: AbstractControl;
    public start_citation: AbstractControl;
    public end_citation: AbstractControl;
    public come_medical_exams: AbstractControl;
    public date_come_medical_exams: AbstractControl;
    public date_medical_appointment: AbstractControl;
    public date_medical_appointment_result: AbstractControl;
    public date_medical_appointment_two: AbstractControl;
    public date_medical_appointment_result_two: AbstractControl;
    public date_medical_appointment_three: AbstractControl;
    public date_medical_appointment_result_three: AbstractControl;

    public interviewed_by_id: AbstractControl;
    public observation_interview: AbstractControl;
    public observation_personal_familiar: AbstractControl;
    public academic_information: AbstractControl;
    public work_experience: AbstractControl;
    public observation_final_concept: AbstractControl;

    public result_interview: AbstractControl;
    public selectedResultInterview: {label: string, value: string};
    public start_interview: AbstractControl;
    public end_interview: AbstractControl;

    public send_customer_by_id: AbstractControl;
    public observation_send_customer: AbstractControl;
    public result_send_customer: AbstractControl;
    public selectedResultSendCustomer: {label: string, value: string};
    public start_send_customer: AbstractControl;
    public end_send_customer: AbstractControl;

    public tested_by_id: AbstractControl;
    public test: AbstractControl;
    public observation_test: AbstractControl;
    public result_test: AbstractControl;
    public selectedResultTest: {label: string, value: string};
    public start_test: AbstractControl;
    public end_test: AbstractControl;

    public documental_analysis_by_id: AbstractControl;
    public observation_documental_analysis: AbstractControl;
    public result_documental_analysis: AbstractControl;
    public selectedResultDocumentalAnalysis: {label: string, value: string};
    public start_documental_analysis: AbstractControl;
    public end_documental_analysis: AbstractControl;

    public background_validation_by_id: AbstractControl;
    public observation_background_validation: AbstractControl;
    public result_background_validation: AbstractControl;
    public selectedResultBackgroundValidation: {label: string, value: string};
    public start_background_validation: AbstractControl;
    public end_background_validation: AbstractControl;

    public referencing_by_id: AbstractControl;
    public observation_referencing: AbstractControl;
    public result_referencing: AbstractControl;
    public selectedResultReferencing: {label: string, value: string};
    public start_referencing: AbstractControl;
    public end_referencing: AbstractControl;

    public medical_exams_by_id: AbstractControl;
    public observation_medical_exams: AbstractControl;
    public result_medical_exams: AbstractControl;
    public selectedResultMedicalExams: {label: string, value: string};
    public lab_medical_exams: AbstractControl;
    public start_medical_exams: AbstractControl;
    public end_medical_exams: AbstractControl;

    public send_hiring: AbstractControl;
    public start_send_hiring: AbstractControl;

    public send_hiring_sign: AbstractControl;
    public start_send_hiring_sign: AbstractControl;

    public hire_by_id: AbstractControl;
    public hiring_analyst_id: AbstractControl;
    public manager_send_hiring_sign_by_id: AbstractControl;
    public observation_hire: AbstractControl;
    public result_hire: AbstractControl;
    public selectedResultHire: {label: string, value: string};
    public start_hire: AbstractControl;
    public end_hire: AbstractControl;
    public accordance_hire: AbstractControl;
    public observation_hire_accordance: AbstractControl;

    public second_accordance_hire: AbstractControl;
    public external_error_hire: AbstractControl;
    public internal_error_hire: AbstractControl;
    public treatment_hire: AbstractControl;
    public verify_hire_by_id: AbstractControl;
    public approval_hire_by_id: AbstractControl;

    public cost_center: AbstractControl;
    public admission_date: AbstractControl;
    public person_labor: AbstractControl;
    public person_arl: AbstractControl;
    public person_additional_requirements: AbstractControl;
    public salary_type: AbstractControl;

    public requisition_id: AbstractControl;
    // public updated_by_id: AbstractControl;
    public created_at: AbstractControl;
    public updated_at: AbstractControl;
    public delete_at: AbstractControl;
    public state_backup: AbstractControl;
    public observation_backup: AbstractControl;
    public salary: AbstractControl;

    public customer_guide_id: number;

    public employeePositionToLoadSelection: string;
    public employeePositionToLoadDocumental: string;
    public employeePositionToLoadHire: string;
    public es: any;

    public resultOptions: SelectItem[];
    public resultOptionsDocumental: SelectItem[];
    public resultOptionsHire: SelectItem[];
    public resultOptionsSelection: SelectItem[];
    public resultOptionsMedical: SelectItem[];
    public resultOptionsReferencing: SelectItem[];
    // public statusOptions: SelectItem[];
    public optionsSelectionStateBackups: SelectItem[];
    public optionsSelectionObservationBackups: SelectItem[];
    public managementOptions: SelectItem[];
    public selectedManagement: {label: string, value: string};


    public sourceOptions: SelectItem[];
    public selectedSource: {label: string, value: string};

    public requisitions: Attendance[];
    public modViewDialog: boolean;

    public login_employee_id: number;
    public myEmployeeId: string;
    public myEmployee: string;

    public new_candidate_id: any;

    public emergency_contact: AbstractControl;
    public emergency_contact_number: AbstractControl;

    public modViewSpeechTextDialog: boolean;


    constructor(
        fb: FormBuilder,
        public synergocitationService: SynergoCitationService,
        public translate: TranslateService,
        public hasPermissionService: HasPermissionService,
        private ngZone: NgZone,
        private notificationsService: NotificationsService,
        public uploadFilesService: UploadFilesService,
        public requisitionService: RequisitionService) {

        this.requisitions = [];
        this.modViewDialog = false;
        this.modViewSpeechTextDialog = false;

        this.login_employee_id = JSON.parse(localStorage.getItem('profile')).employee_id;

        this.employeePositionToLoadSelection = '4,5,6,7,8,9,10,24,25,38,53';
        this.employeePositionToLoadDocumental = '4,5,6,7,8,9,10,24,25,38,53';
        this.employeePositionToLoadHire = '5,6,7,8,9,10,24,25,38,53';

        this.resultOptions = [
            // {label: 'Pendiente', value: 'Pendiente'},
            // {label: 'En Proceso', value: 'En Proceso'},
            {label: 'No Apto', value: 'No Apto'},
            {label: 'Novedad', value: 'Novedad'},
            {label: 'Favorable', value: 'Favorable'},
            {label: 'Autorizado', value: 'Autorizado'},
            {label: 'No asistió', value: 'No asistió'},
        ];
        this.resultOptionsReferencing = [
            {label: 'No Apto', value: 'No Apto'},
            {label: 'Novedad', value: 'Novedad'},
            {label: 'Favorable', value: 'Favorable'},
            {label: 'Autorizado', value: 'Autorizado'},
            {label: 'Reingreso', value: 'Reingreso'},
            {label: 'Sin Documentos', value: 'Sin Documentos'},
        ];

        this.resultOptionsMedical = [
            // {label: 'Pendiente', value: 'Pendiente'},
            // {label: 'En Proceso', value: 'En Proceso'},
            {label: 'No Apto', value: 'No Apto'},
            {label: 'Compromiso', value: 'Compromiso'},
            {label: 'Favorable', value: 'Favorable'},
            {label: 'Autorizado', value: 'Autorizado'},
            {label: 'Aplazado', value: 'Aplazado'},
            {label: 'No asistió', value: 'No asistió'},
            {label: 'Candidato en atención', value: 'Candidato en atención'},
            {label: 'No ha llegado el examen médico al correo', value: 'No ha llegado el examen médico al correo'},
            {label: 'Se esta ampliando información', value: 'Se esta ampliando información'},
            {label: 'Pendiente cierre de historia clinica', value: 'Pendiente cierre de historia clinica'},

        ];

        this.resultOptionsSelection = [
            {label: 'No Apto', value: 'No Apto'},
            {label: 'Novedad', value: 'Novedad'},
            {label: 'Favorable', value: 'Favorable'},
            {label: 'Autorizado', value: 'Autorizado'},
            {label: 'No Contestó', value: 'No Contestó'},
            {label: 'No asistió', value: 'No asistió'},
        ];

        this.resultOptionsDocumental = [
            {label: 'No Apto', value: 'No Apto'},
            {label: 'Novedad', value: 'Novedad'},
            {label: 'Favorable', value: 'Favorable'},
            {label: 'Autorizado', value: 'Autorizado'},
            {label: 'Revisado', value: 'Revisado'},
            {label: 'Sin Documentos', value: 'Sin Documentos'},
        ];

        this.resultOptionsHire = [
            // {label: 'Pendiente', value: 'Pendiente'},
            // {label: 'En Proceso', value: 'En Proceso'},
            // {label: 'No Apto', value: 'No Apto'},
            // {label: 'Novedad', value: 'Novedad'},
            {label: 'Contratado', value: 'Contratado'},
            {label: 'No contratado', value: 'No contratado'},
            {label: 'Inejecución', value: 'Inejecución'},
            {label: 'Desitió', value: 'Desistió'},
        ];

        this.sourceOptions = [
            {label: 'Volanteo', value: 'Volanteo'},
            {label: 'Portal de candidatos', value: 'Portal de candidatos'},
            {label: 'Bolsa de Trabajo de la Universidad', value: 'Bolsa de Trabajo de la Universidad'},
            {label: 'Mercado Natural', value: 'Mercado Natural'},
            {label: 'Computrabajo', value: 'Computrabajo'},
            {label: 'El Empleo', value: 'El Empleo'},
            {label: 'Cliente', value: 'Cliente'},
            {label: 'Familiares o Amigos', value: 'Familiares o Amigos'},
            {label: 'Ferias', value: 'Ferias'},
            {label: 'Periódico o Revistas', value: 'Periódico o Revistas'},
            {label: 'Reclutador externo', value: 'Reclutador externo'},
            {label: 'Redes Sociales', value: 'Redes Sociales'},
            {label: 'SENA', value: 'SENA'},
            {label: 'Alentti', value: 'Alentti'},
            {label: 'Vincuventas', value: 'Vincuventas'},
            {label: 'LinkedIn ', value: 'LinkedIn '},
            {label: 'Cajas de compensación', value: 'Cajas de compensación'},
            {label: 'Indeed', value: 'Indeed'},
            {label: 'Hoy Trabajas', value: 'Hoy Trabajas'},
            {label: 'Trabajos Diarios', value: 'Trabajos Diarios'},
            {label: 'Talentu', value: 'Talentu'},
            {label: 'empleosdeleje.com', value: 'empleosdeleje.com'},
            {label: 'Aplicación desde portal candidatos', value: 'Aplicación desde portal candidatos'},
            {label: 'Otro', value: 'Otro'},
        ];

        // this.statusOptions = [
        //     {label: 'Citado', value: 'Citado'},
        //     {label: 'Asistió', value: 'Asistió'},
        //     {label: 'Entrevista', value: 'Entrevista'},
        //     {label: 'Pruebas', value: 'Pruebas'},
        //     {label: 'Enviado A Empresa Usuaria', value: 'Enviado A Empresa Usuaria'},
        //     {label: 'Enviado Para Examen Médico', value: 'Enviado Para Examen Médico'},
        //     {label: 'Citado Para Contratación', value: 'Citado Para Contratación'},
        //     {label: 'Contratado', value: 'Contratado'},
        //     {label: 'No Le Interesa', value: 'No Le Interesa'},
        //     {label: 'No Apto/Descartados', value: 'No Apto/Descartados'},
        // ];


        this.managementOptions = [
            {label: 'Citado', value: 'Citado'},
            {label: 'Citado Para Contratación', value: 'Citado Para Contratación'},
            {label: 'Citado Para Empresa Usuaria', value: 'Citado Para Empresa Usuaria'},
            {label: 'Citado Para Examen Médico', value: 'Citado Para Examen Médico'},
            {label: 'Pendiente Por Citar', value: 'Pendiente Por Citar'},
            {label: 'Reclutamiento Nocturno', value: 'Reclutamiento Nocturno'},
            {label: 'No Contesta', value: 'No Contesta'},
            {label: 'No Le Interesa Por Distancia', value: 'No Le Interesa Por Distancia'},
            {label: 'No Le Interesa Por Horarios', value: 'No Le Interesa Por Horarios'},
            {label: 'No Le Interesa Por Salario', value: 'No Le Interesa Por Salario'},
            {label: 'No le interesa por condiciones laborales', value: 'No le interesa por condiciones laborales'},
            {label: 'Numero Apagado', value: 'Numero Apagado'},
            {label: 'Numero Equivocado', value: 'Numero Equivocado'},
            {label: 'Numero Fuera de Servicio', value: 'Numero Fuera de Servicio'},
            {label: 'Se Deja Mensaje Con Familiar/Amigo', value: 'Se Deja Mensaje Con Familiar/Amigo'},
            {label: 'Se Deja Mensaje De Voz', value: 'Se Deja Mensaje De Voz'},
            {label: 'Se Deja Razon', value: 'Se Deja Razon'},
            {label: 'Se Encuentra En Proceso', value: 'Se Encuentra En Proceso'},
            {label: 'Se Encuentra Estudiando', value: 'Se Encuentra Estudiando'},
            {label: 'Se Encuentra Laborando', value: 'Se Encuentra Laborando'},
            {label: 'Se Encuentra Viajando', value: 'Se Encuentra Viajando'},
            {label: 'Ya Realizo Proceso Con La Misma EU', value: 'Ya Realizo Proceso Con La Misma EU'},
            {label: 'No Cumple Con El Perfil', value: 'No Cumple Con El Perfil'},
            {label: 'Otro', value: 'Otro'},
        ];
        this.optionsSelectionStateBackups=[

            {label:'Seleccionado listo para contratar', value:'Seleccionado listo para contratar'},
            {label:'Pendiente entrevista coordinador', value:'Pendiente entrevista coordinador'},
            {label:'No continua', value:'No continua'},
            {label:'Enviado analista Claro sin retroalimentación', value:'Enviado analista Claro sin retroalimentación'},
            {label:'Contratado', value:'Contratado'},

        ];
        this.optionsSelectionObservationBackups=[
            {label:'No cumple con el perfil', value:'No cumple con el perfil'},
            {label:'No seleccionado por el coordinador', value:'No seleccionado por el coordinador'},
            {label:'Ya no esta disponible', value:'Ya no esta disponible'},
        ];

        this.es = calendarES();

        this.form = fb.group({
            'read': ['', Validators.compose([Validators.minLength(1)])],
            'venue_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'company_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'candidate_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'profile_survey_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'requisition_observation': ['', Validators.compose([Validators.minLength(1)])],
            'management': ['', Validators.compose([Validators.required, Validators.minLength(1)])],

            'date_citations': ['', Validators.compose([Validators.minLength(1)])],
            'source': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'recruited': [''],
            'recruited_at': ['', Validators.compose([Validators.minLength(1)])],
            'recruited_by_id': ['', Validators.compose([Validators.minLength(1)])],
            // 'elaborated_by_id': ['', Validators.compose([Validators.required, Validators.minLength(1)])],
            'called_by_id': ['', Validators.compose([Validators.minLength(1)])],
            // 'time': ['', Validators.compose([Validators.minLength(1)])],
            'observation_citation': ['', Validators.compose([Validators.minLength(1)])],
            'attended': [''],
            // 'arrival_time': ['', Validators.compose([Validators.minLength(1)])],

            'interviewed_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_interview': ['', Validators.compose([Validators.minLength(1)])],
            'observation_personal_familiar': ['', Validators.compose([Validators.minLength(1)])],
            'academic_information': ['', Validators.compose([Validators.minLength(1)])],
            'work_experience': ['', Validators.compose([Validators.minLength(1)])],
            'observation_final_concept': ['', Validators.compose([Validators.minLength(1)])],

            'result_interview': ['', Validators.compose([Validators.minLength(1)])],
            'start_interview': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_interview': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'emergency_contact': ['', Validators.compose([Validators.minLength(2)])],
            'emergency_contact_number': ['', Validators.compose([Validators.pattern("^[0-9]*$")])],

            'send_customer_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_send_customer': ['', Validators.compose([Validators.minLength(1)])],
            'result_send_customer': ['', Validators.compose([Validators.minLength(1)])],
            'start_send_customer': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_send_customer': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],

            'tested_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'test': ['', Validators.compose([Validators.minLength(1)])],
            'observation_test': ['', Validators.compose([Validators.minLength(1)])],
            'result_test': ['', Validators.compose([Validators.minLength(1)])],
            'start_test': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_test': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],

            'documental_analysis_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_documental_analysis': ['', Validators.compose([Validators.minLength(1)])],
            'result_documental_analysis': ['', Validators.compose([Validators.minLength(1)])],
            'start_documental_analysis': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_documental_analysis': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],

            'referencing_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_referencing': ['', Validators.compose([Validators.minLength(1)])],
            'result_referencing': ['', Validators.compose([Validators.minLength(1)])],
            'start_referencing': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_referencing': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],

            'background_validation_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_background_validation': ['', Validators.compose([Validators.minLength(1)])],
            'result_background_validation': ['', Validators.compose([Validators.minLength(1)])],
            'start_background_validation': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_background_validation': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],

            'medical_exams_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'observation_medical_exams': ['', Validators.compose([Validators.minLength(1)])],
            'result_medical_exams': ['', Validators.compose([Validators.minLength(1)])],
            'lab_medical_exams': ['', Validators.compose([Validators.minLength(1)])],
            'start_medical_exams': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_medical_exams': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'come_medical_exams': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'date_come_medical_exams': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment': ['', Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment_result': ['', Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment_two': ['', Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment_result_two': ['', Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment_three': ['', Validators.compose([Validators.minLength(1)])],
            'date_medical_appointment_result_three': ['', Validators.compose([Validators.minLength(1)])],
            'send_hiring': [''],
            'start_send_hiring': [{value: '', disabled: true}],

            'send_hiring_sign': [''],
            'start_send_hiring_sign': [{value: '', disabled: true}],

            'hire_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'hiring_analyst_id': ['', Validators.compose([Validators.minLength(1)])],
            'manager_send_hiring_sign_by_id':['',Validators.compose([Validators.minLength(1)])],
            'observation_hire': ['', Validators.compose([Validators.minLength(1)])],
            'result_hire': ['', Validators.compose([Validators.minLength(1)])],
            'start_hire': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'end_hire': [{value: '', disabled: true}, Validators.compose([Validators.minLength(1)])],
            'accordance_hire': ['', Validators.compose([Validators.minLength(1)])],
            'observation_hire_accordance': ['', Validators.compose([Validators.minLength(1)])],
            'cost_center': ['', Validators.compose([Validators.minLength(1)])],
            'admission_date': ['', Validators.compose([Validators.minLength(1)])],
            'salary_type': ['', Validators.compose([Validators.minLength(1)])],
            'person_labor': ['', Validators.compose([Validators.minLength(1)])],
            'person_arl': ['', Validators.compose([Validators.minLength(1)])],
            'person_additional_requirements': ['', Validators.compose([Validators.minLength(1)])],

            'second_accordance_hire': ['', Validators.compose([Validators.minLength(1)])],
            'external_error_hire': ['', Validators.compose([Validators.minLength(1)])],
            'internal_error_hire': ['', Validators.compose([Validators.minLength(1)])],
            'treatment_hire': ['', Validators.compose([Validators.minLength(1)])],
            'verify_hire_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'approval_hire_by_id': ['', Validators.compose([Validators.minLength(1)])],

            // 'updated_by_id': ['', Validators.compose([Validators.minLength(1)])],
            'requisition_id': ['', Validators.compose([Validators.minLength(1)])],
            'state_backup':[''],
            'observation_backup':[''],
            'salary':['', Validators.compose([Validators.minLength(1)])],
        });

        this.read = this.form.controls['read'];
        this.venue_id = this.form.controls['venue_id'];
        this.company_id = this.form.controls['company_id'];
        this.profile_survey_id = this.form.controls['profile_survey_id'];
        this.requisition_observation = this.form.controls['requisition_observation'];
        this.candidate_id = this.form.controls['candidate_id'];
        this.management = this.form.controls['management'];
        this.date_citations = this.form.controls['date_citations'];
        this.source = this.form.controls['source'];


        this.recruited = this.form.controls['recruited'];
        this.recruited_at = this.form.controls['recruited_at'];
        this.recruited_by_id = this.form.controls['recruited_by_id'];
        // this.elaborated_by_id = this.form.controls['elaborated_by_id'];
        this.start_citation = this.form.controls['start_citation'];
        this.end_citation = this.form.controls['end_citation'];

        this.interviewed_by_id = this.form.controls['interviewed_by_id'];
        this.observation_interview = this.form.controls['observation_interview'];
        this.observation_personal_familiar = this.form.controls['observation_personal_familiar'];
        this.academic_information = this.form.controls['academic_information'];
        this.work_experience = this.form.controls['work_experience'];
        this.observation_final_concept = this.form.controls['observation_final_concept'];

        this.result_interview = this.form.controls['result_interview'];
        this.start_interview = this.form.controls['start_interview'];
        this.end_interview = this.form.controls['end_interview'];
        this.emergency_contact = this.form.controls['emergency_contact'];
        this.emergency_contact_number = this.form.controls['emergency_contact_number'];

        this.send_customer_by_id = this.form.controls['send_customer_by_id'];
        this.observation_send_customer = this.form.controls['observation_send_customer'];
        this.result_send_customer = this.form.controls['result_send_customer'];
        this.start_send_customer = this.form.controls['start_send_customer'];
        this.end_send_customer = this.form.controls['end_send_customer'];

        this.called_by_id = this.form.controls['called_by_id'];
        // this.time = this.form.controls['time'];
        this.observation_citation = this.form.controls['observation_citation'];
        this.attended = this.form.controls['attended'];
        // this.arrival_time = this.form.controls['arrival_time'];

        this.tested_by_id = this.form.controls['tested_by_id'];
        this.test = this.form.controls['test'];
        this.observation_test = this.form.controls['observation_test'];
        this.result_test = this.form.controls['result_test'];
        this.start_test = this.form.controls['start_test'];
        this.end_test = this.form.controls['end_test'];

        this.documental_analysis_by_id = this.form.controls['documental_analysis_by_id'];
        this.observation_documental_analysis = this.form.controls['observation_documental_analysis'];
        this.result_documental_analysis = this.form.controls['result_documental_analysis'];
        this.start_documental_analysis = this.form.controls['start_documental_analysis'];
        this.end_documental_analysis = this.form.controls['end_documental_analysis'];

        this.referencing_by_id = this.form.controls['referencing_by_id'];
        this.observation_referencing = this.form.controls['observation_referencing'];
        this.result_referencing = this.form.controls['result_referencing'];
        this.start_referencing = this.form.controls['start_referencing'];
        this.end_referencing = this.form.controls['end_referencing'];

        this.background_validation_by_id = this.form.controls['background_validation_by_id'];
        this.observation_background_validation = this.form.controls['observation_background_validation'];
        this.result_background_validation = this.form.controls['result_background_validation'];
        this.start_background_validation = this.form.controls['start_background_validation'];
        this.end_background_validation = this.form.controls['end_background_validation'];

        this.medical_exams_by_id = this.form.controls['medical_exams_by_id'];
        this.observation_medical_exams = this.form.controls['observation_medical_exams'];
        this.result_medical_exams = this.form.controls['result_medical_exams'];
        this.lab_medical_exams = this.form.controls['lab_medical_exams'];
        this.start_medical_exams = this.form.controls['start_medical_exams'];
        this.end_medical_exams = this.form.controls['end_medical_exams'];
        this.come_medical_exams = this.form.controls['come_medical_exams'];
        this.date_come_medical_exams = this.form.controls['date_come_medical_exams'];
        this.date_medical_appointment = this.form.controls['date_medical_appointment'];
        this.date_medical_appointment_result = this.form.controls['date_medical_appointment_result'];
        this.date_medical_appointment_two = this.form.controls['date_medical_appointment_two'];
        this.date_medical_appointment_result_two = this.form.controls['date_medical_appointment_result_two'];
        this.date_medical_appointment_three = this.form.controls['date_medical_appointment_three'];
        this.date_medical_appointment_result_three = this.form.controls['date_medical_appointment_result_three'];

        this.send_hiring = this.form.controls['send_hiring'];
        this.start_send_hiring = this.form.controls['start_send_hiring'];

        this.send_hiring_sign = this.form.controls['send_hiring_sign'];
        this.start_send_hiring_sign = this.form.controls['start_send_hiring_sign'];

        this.hire_by_id = this.form.controls['hire_by_id'];
        this.hiring_analyst_id = this.form.controls['hiring_analyst_id'];
        this.manager_send_hiring_sign_by_id=this.form.controls['manager_send_hiring_sign_by_id'];
        this.observation_hire = this.form.controls['observation_hire'];
        this.result_hire = this.form.controls['result_hire'];
        this.start_hire = this.form.controls['start_hire'];
        this.end_hire = this.form.controls['end_hire'];
        this.accordance_hire = this.form.controls['accordance_hire'];
        this.observation_hire_accordance = this.form.controls['observation_hire_accordance'];

        this.cost_center = this.form.controls['cost_center'];
        this.admission_date = this.form.controls['admission_date'];
        this.person_labor = this.form.controls['person_labor'];
        this.person_arl = this.form.controls['person_arl'];
        this.person_additional_requirements = this.form.controls['person_additional_requirements'];
        this.salary_type = this.form.controls['salary_type'];


        this.second_accordance_hire = this.form.controls['second_accordance_hire'];
        this.external_error_hire = this.form.controls['external_error_hire'];
        this.internal_error_hire = this.form.controls['internal_error_hire'];
        this.treatment_hire = this.form.controls['treatment_hire'];
        this.verify_hire_by_id = this.form.controls['verify_hire_by_id'];
        this.approval_hire_by_id = this.form.controls['approval_hire_by_id'];

        // this.updated_by_id = this.form.controls['updated_by_id'];
        this.requisition_id = this.form.controls['requisition_id'];
        this.state_backup = this.form.controls['state_backup'];
        this.observation_backup = this.form.controls['observation_backup'];
        this.salary = this.form.controls['salary'];
    }

    ngOnInit() {
        this.myEmployeeId = JSON.parse(localStorage.getItem('profile')).employee_id;
        this.myEmployee = JSON.parse(localStorage.getItem('profile')).employee;
        if (this.edit) {
            this.read.setValue(this.edit.read);
            this.venue_id.setValue(this.edit.venue_id);
            this.company_id.setValue(this.edit.company_id);
            this.candidate_id.setValue(this.edit.candidate);
            this.profile_survey_id.setValue(this.edit.profile_survey_id);
            this.requisition_observation.setValue(this.edit.requisition.observation);

            if (this.edit.file_test) {
                this.uploadedFileTest = [];
                this.uploadedFileTest.push({'name': 'Archivo Adjunto  '});
            }

            // this.management.setValue(this.edit.management);
            this.selectedManagement = {label: this.edit.management, value: this.edit.management};
            this.date_citations.setValue(new Date(this.edit.date_citations));
            if (this.edit.admission_date) {
                this.admission_date.setValue(new Date(this.edit.admission_date));
            }
            // this.source.setValue(this.edit.source);
            this.selectedSource = {label: this.edit.source, value: this.edit.source};
            this.recruited.setValue(this.edit.recruited);
            this.recruited_at.setValue(this.edit.recruited_at);
            this.recruited_by_id.setValue(this.edit.recruited_by_id);
            // this.elaborated_by_id.setValue(this.edit.elaborated_by_id);
            this.observation_interview.setValue(this.edit.observation_interview);
            this.called_by_id.setValue(this.edit.called_by_id);
            // this.time.setValue(this.edit.time);
            this.observation_citation.setValue(this.edit.observation_citation);
            this.attended.setValue(this.edit.attended);
            // this.arrival_time.setValue(this.edit.arrival_time);

            this.interviewed_by_id.setValue(this.edit.interviewed_by);
            this.observation_interview.setValue(this.edit.observation_interview);
            this.observation_personal_familiar.setValue(this.edit.observation_personal_familiar);
            this.academic_information.setValue(this.edit.academic_information);
            this.work_experience.setValue(this.edit.work_experience);
            this.observation_final_concept.setValue(this.edit.observation_final_concept);

            // this.result_interview.setValue(this.edit.result_interview);
            this.selectedResultInterview = {label: this.edit.result_interview, value: this.edit.result_interview};

            if (this.edit.start_interview) {
                this.start_interview.setValue(new Date(this.edit.start_interview));
            }

            if (this.edit.end_interview) {
                this.end_interview.setValue(new Date(this.edit.end_interview));
            }

            this.emergency_contact.setValue(this.edit.emergency_contact);
            this.emergency_contact_number.setValue(this.edit.emergency_contact_number);

            this.send_customer_by_id.setValue(this.edit.send_customer_by);
            this.observation_send_customer.setValue(this.edit.observation_send_customer);
            // this.result_send_customer.setValue(this.edit.result_send_customer);
            this.selectedResultSendCustomer = {label: this.edit.result_send_customer, value: this.edit.result_send_customer};
            if (this.edit.start_send_customer) {
                this.start_send_customer.setValue(new Date(this.edit.start_send_customer));
            }

            this.tested_by_id.setValue(this.edit.tested_by);
            this.test.setValue(this.edit.test);
            this.observation_test.setValue(this.edit.observation_test);
            // this.result_test.setValue(this.edit.result_test);
            this.selectedResultTest = {label: this.edit.result_test, value: this.edit.result_test};
            if (this.edit.start_test) {
                this.start_test.setValue(new Date(this.edit.start_test));
            }
            if (this.edit.end_test) {
                this.end_test.setValue(new Date(this.edit.end_test));
            }

            this.documental_analysis_by_id.setValue(this.edit.documental_analysis_by);
            this.observation_documental_analysis.setValue(this.edit.observation_documental_analysis);
            // this.result_documental_analysis.setValue(this.edit.result_documental_analysis);
            this.selectedResultDocumentalAnalysis = {label: this.edit.result_documental_analysis,
                value: this.edit.result_documental_analysis};
            if (this.edit.start_documental_analysis) {
                this.start_documental_analysis.setValue(new Date(this.edit.start_documental_analysis));
            }
            if (this.edit.end_documental_analysis) {
                this.end_documental_analysis.setValue(new Date(this.edit.end_documental_analysis));
            }

            this.referencing_by_id.setValue(this.edit.referencing_by);
            this.observation_referencing.setValue(this.edit.observation_referencing);
            // this.result_referencing.setValue(this.edit.result_referencing);
            this.selectedResultReferencing = {label: this.edit.result_referencing, value: this.edit.result_referencing};
            if (this.edit.start_referencing) {
                this.start_referencing.setValue(new Date(this.edit.start_referencing));
            }
            if (this.edit.end_referencing) {
                this.end_referencing.setValue(new Date(this.edit.end_referencing));
            }

            this.background_validation_by_id.setValue(this.edit.background_validation_by_id);
            this.observation_background_validation.setValue(this.edit.observation_background_validation);
            // this.result_background_validation.setValue(this.edit.result_background_validation);
            this.selectedResultBackgroundValidation = {label: this.edit.result_background_validation, value: this.edit.result_background_validation};
            if (this.edit.start_background_validation) {
                this.start_background_validation.setValue(new Date(this.edit.start_background_validation));
            }
            if (this.edit.end_background_validation) {
                this.end_background_validation.setValue(new Date(this.edit.end_referencing));
            }

            this.medical_exams_by_id.setValue(this.edit.medical_exams_by);
            this.observation_medical_exams.setValue(this.edit.observation_medical_exams);
            // this.result_medical_exams.setValue(this.edit.result_medical_exams);
            this.selectedResultMedicalExams = {label: this.edit.result_medical_exams, value: this.edit.result_medical_exams};
            if(this.edit.result_medical_exams=='No Apto')
                this.result_medical_exams.disable();
            this.lab_medical_exams.setValue(this.edit.lab_medical_exams);
            if (this.edit.start_medical_exams) {
                this.start_medical_exams.setValue(new Date(this.edit.start_medical_exams));
            }
            if (this.edit.end_medical_exams) {
                this.end_medical_exams.setValue(new Date(this.edit.end_medical_exams));
            }

            if (this.edit.date_come_medical_exams) {
                this.date_come_medical_exams.setValue(new Date(this.edit.date_come_medical_exams));
            }
            if (this.edit.date_medical_appointment) {
                this.date_medical_appointment.setValue(new Date(this.edit.date_medical_appointment));
            }
            if (this.edit.date_medical_appointment_result) {
                this.date_medical_appointment_result.setValue(new Date(this.edit.date_medical_appointment_result));
            }
            if (this.edit.date_medical_appointment_two) {
                this.date_medical_appointment_two.setValue(new Date(this.edit.date_medical_appointment_two));
            }
            if (this.edit.date_medical_appointment_result_two) {
                this.date_medical_appointment_result_two.setValue(new Date(this.edit.date_medical_appointment_result_two));
            }
            if (this.edit.date_medical_appointment_three)
                this.date_medical_appointment_three.setValue(new Date(this.edit.date_medical_appointment_three));
            if (this.edit.date_medical_appointment_result_three)
                this.date_medical_appointment_result_three.setValue(new Date(this.edit.date_medical_appointment_result_three));


            this.send_hiring.setValue(this.edit.send_hiring);
            if (this.edit.start_send_hiring) {
                this.start_send_hiring.setValue(new Date(this.edit.start_send_hiring));
            }

            this.send_hiring_sign.setValue(this.edit.send_hiring_sign);
            if (this.edit.start_send_hiring_sign) {
                this.start_send_hiring_sign.setValue(new Date(this.edit.start_send_hiring_sign));
            }

            this.hire_by_id.setValue(this.edit.hire_by_id);
            this.hiring_analyst_id.setValue(this.edit.hiring_analyst_id);
            this.manager_send_hiring_sign_by_id.setValue(this.edit.manager_send_hiring_sign_by_id);
            this.observation_hire.setValue(this.edit.observation_hire);
            // this.result_hire.setValue(this.edit.result_hire);
            this.selectedResultHire = {label: this.edit.result_hire, value: this.edit.result_hire};
            if (this.edit.start_hire) {
                this.start_hire.setValue(new Date(this.edit.start_hire));
            }
            if (this.edit.end_hire) {
                this.end_hire.setValue(new Date(this.edit.end_hire));
            }
            this.accordance_hire.setValue(this.edit.accordance_hire);
            this.observation_hire_accordance.setValue(this.edit.observation_hire_accordance);
            this.cost_center.setValue(this.edit.cost_center);
            this.person_labor.setValue(this.edit.person_labor);
            this.person_arl.setValue(this.edit.person_arl);
            this.person_additional_requirements.setValue(this.edit.person_additional_requirements);
            this.salary_type.setValue(this.edit.salary_type);
            this.salary.setValue(this.edit.salary);

            this.second_accordance_hire.setValue(this.edit.second_accordance_hire);
            this.external_error_hire.setValue(this.edit.external_error_hire);
            this.internal_error_hire.setValue(this.edit.internal_error_hire);
            this.treatment_hire.setValue(this.edit.treatment_hire);
            this.verify_hire_by_id.setValue(this.edit.verify_hire_by_id);
            this.approval_hire_by_id.setValue(this.edit.approval_hire_by_id);

            // this.updated_by_id.setValue(this.edit.updated_by);
            this.requisition_id.setValue(this.edit.requisition_id);
            if(this.edit.state_backup != null)
                this.state_backup.setValue(this.edit.state_backup);
            if(this.edit.observation_backup != null)
                this.observation_backup.setValue(this.edit.observation_backup);
            if (this.edit.source != '' || this.edit.source != null) 
            {
                this.form.get('source').clearValidators();
                this.form.get('source').updateValueAndValidity();
                this.form.controls['source'].disable();
            }
        } else {
            if (this.idCitation) {
                const filters = [];
                filters.push({'key': 'id', 'value': this.idCitation});
                this.getSynergoCitations(undefined, filters);
            }

            if (this.myEmployee) {
                this.recruited_by_id.setValue(this.myEmployee);
                this.called_by_id.setValue(this.myEmployee);
                /*this.hire_by_id.setValue(this.myEmployee);
                this.interviewed_by_id.setValue(this.myEmployee);
                this.send_customer_by_id.setValue(this.myEmployee);
                this.documental_analysis_by_id.setValue(this.myEmployee);
                this.referencing_by_id.setValue(this.myEmployee);
                this.tested_by_id.setValue(this.myEmployee);
                this.medical_exams_by_id.setValue(this.myEmployee);
                */
            }
            // this.station_status.setValue(false);
        }

        this.getRequisitions(this.idRequisition);
    }

    ngOnChanges() {
        if (this.edit) {
            this.read.setValue(this.edit.read);
            this.venue_id.setValue(this.edit.venue_id);
            this.company_id.setValue(this.edit.company_id);
            this.candidate_id.setValue(this.edit.candidate);
            this.profile_survey_id.setValue(this.edit.profile_survey_id);
            this.requisition_observation.setValue(this.edit.requisition.observation);
            this.management.setValue(this.edit.management);
            // this.status.setValue(this.edit.status);
            this.date_citations.setValue(new Date(this.edit.date_citations));
            this.source.setValue(this.edit.source);
            this.recruited.setValue(this.edit.recruited);
            this.recruited_at.setValue(this.edit.recruited_at);
            this.recruited_by_id.setValue(this.edit.recruited_by_id);
            // this.elaborated_by_id.setValue(this.edit.elaborated_by_id);
            this.observation_interview.setValue(this.edit.observation_interview);

            this.called_by_id.setValue(this.edit.called_by_id);
            // this.time.setValue(this.edit.time);
            this.observation_citation.setValue(this.edit.observation_citation);
            this.attended.setValue(this.edit.attended);
            // this.arrival_time.setValue(this.edit.arrival_time);

            this.interviewed_by_id.setValue(this.edit.interviewed_by);
            this.observation_interview.setValue(this.edit.observation_interview);
            this.observation_personal_familiar.setValue(this.edit.observation_personal_familiar);
            this.academic_information.setValue(this.edit.academic_information);
            this.work_experience.setValue(this.edit.work_experience);
            this.observation_final_concept.setValue(this.edit.observation_final_concept);
            this.result_interview.setValue(this.edit.result_interview);
            if (this.edit.start_interview) {
                this.start_interview.setValue(new Date(this.edit.start_interview));
            }
            if (this.edit.end_interview) {
                this.end_interview.setValue(new Date(this.edit.end_interview));
            }

            this.send_customer_by_id.setValue(this.edit.send_customer_by);
            this.observation_send_customer.setValue(this.edit.observation_send_customer);
            this.result_send_customer.setValue(this.edit.result_send_customer);
            if (this.edit.start_send_customer) {
                this.start_send_customer.setValue(new Date(this.edit.start_send_customer));
            }

            this.tested_by_id.setValue(this.edit.tested_by);
            this.test.setValue(this.edit.test);
            this.observation_test.setValue(this.edit.observation_test);
            this.result_test.setValue(this.edit.result_test);
            if (this.edit.start_test) {
                this.start_test.setValue(new Date(this.edit.start_test));
            }
            if (this.edit.end_test) {
                this.end_test.setValue(new Date(this.edit.end_test));
            }

            this.documental_analysis_by_id.setValue(this.edit.documental_analysis_by);
            this.observation_documental_analysis.setValue(this.edit.observation_documental_analysis);
            this.result_documental_analysis.setValue(this.edit.result_documental_analysis);
            if (this.edit.start_documental_analysis) {
                this.start_documental_analysis.setValue(new Date(this.edit.start_documental_analysis));
            }
            if (this.edit.end_documental_analysis) {
                this.end_documental_analysis.setValue(new Date(this.edit.end_documental_analysis));
            }

            this.background_validation_by_id.setValue(this.edit.background_validation_by);
            this.observation_background_validation.setValue(this.edit.observation_background_validation);
            this.result_background_validation.setValue(this.edit.result_background_validation);
            if (this.edit.start_background_validation) {
                this.start_background_validation.setValue(new Date(this.edit.start_background_validation));
            }
            if (this.edit.end_background_validation) {
                this.end_background_validation.setValue(new Date(this.edit.end_background_validation));
            }

            this.referencing_by_id.setValue(this.edit.referencing_by);
            this.observation_referencing.setValue(this.edit.observation_referencing);
            this.result_referencing.setValue(this.edit.result_referencing);
            if (this.edit.start_referencing) {
                this.start_referencing.setValue(new Date(this.edit.start_referencing));
            }
            if (this.edit.end_referencing) {
                this.end_referencing.setValue(new Date(this.edit.end_referencing));
            }

            this.medical_exams_by_id.setValue(this.edit.medical_exams_by);
            this.observation_medical_exams.setValue(this.edit.observation_medical_exams);
            this.result_medical_exams.setValue(this.edit.result_medical_exams);
            this.lab_medical_exams.setValue(this.edit.lab_medical_exams);
            if (this.edit.start_medical_exams) {
                this.start_medical_exams.setValue(new Date(this.edit.start_medical_exams));
            }

            if (this.edit.end_medical_exams) {
                this.end_medical_exams.setValue(new Date(this.edit.end_medical_exams));
            }

            if (this.edit.date_come_medical_exams) {
                this.date_come_medical_exams.setValue(new Date(this.edit.date_come_medical_exams));
            }

            this.send_hiring.setValue(this.edit.send_hiring);
            if (this.edit.start_send_hiring) {
                this.start_send_hiring.setValue(new Date(this.edit.start_send_hiring));
            }

            this.send_hiring_sign.setValue(this.edit.send_hiring_sign);
            if (this.edit.start_send_hiring_sign) {
                this.start_send_hiring_sign.setValue(new Date(this.edit.start_send_hiring_sign));
            }

            this.hire_by_id.setValue(this.edit.hire_by_id);
            this.hiring_analyst_id.setValue(this.edit.hiring_analyst_id);
            this.manager_send_hiring_sign_by_id.setValue(this.edit.manager_send_hiring_sign_by_id);
            this.observation_hire.setValue(this.edit.observation_hire);
            this.result_hire.setValue(this.edit.result_hire);
            if (this.edit.start_hire) {
                this.start_hire.setValue(new Date(this.edit.start_hire));
            }
            if (this.edit.end_hire) {
                this.end_hire.setValue(new Date(this.edit.end_hire));
            }
            this.accordance_hire.setValue(this.edit.accordance_hire);
            this.observation_hire_accordance.setValue(this.edit.observation_hire_accordance);

            this.second_accordance_hire.setValue(this.edit.second_accordance_hire);
            this.external_error_hire.setValue(this.edit.external_error_hire);
            this.internal_error_hire.setValue(this.edit.internal_error_hire);
            this.treatment_hire.setValue(this.edit.treatment_hire);
            this.verify_hire_by_id.setValue(this.edit.verify_hire_by_id);
            this.approval_hire_by_id.setValue(this.edit.approval_hire_by_id);
            if (this.edit.admission_date) {
                this.admission_date.setValue(new Date(this.edit.admission_date));
            }
            // this.updated_by_id.setValue(this.edit.updated_by);
            this.requisition_id.setValue(this.edit.requisition_id);
            if(this.editPart == 'interview'){
                this.form.get('emergency_contact').setValidators([Validators.required, Validators.minLength(1)]);
                this.form.get('emergency_contact_number').setValidators([Validators.required, Validators.minLength(1)]);
            }
            else{
                this.form.get('emergency_contact').setValidators([]);
                this.form.get('emergency_contact_number').setValidators([]);
            }
            if ((
                this.edit.company_id == '288' ||
                this.edit.company_id == '290' ||
                this.edit.company_id == '287' ||
                this.edit.company_id == '286' ||
                this.edit.company_id == '306' ||
                this.edit.company_id == '305' ||
                this.edit.company_id == '310' ||
                this.edit.company_id == '304' ||
                this.edit.company_id == '309' ||
                this.edit.company_id == '314' ||
                this.edit.company_id == '614' ||
                this.edit.company_id == '302' ) &&
                (this.editPart == 'medical_exams' || this.editPart == 'allinone')
                ) {
                this.form.get('cost_center').setValidators([Validators.required, Validators.minLength(1)]);
            }
        } else {
            // this.station_status.setValue(false);
        }

        this.getRequisitions(this.idRequisition);
    }

    public cancelCitation () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }

    public newSynergoCitation(values) {
        let param;

        let recruited_by_id;
        if (values.recruited_by_id) {
            if (values.recruited_by_id.id) {
                recruited_by_id = values.recruited_by_id.id;
            } else {
                recruited_by_id = values.recruited_by_id;
            }
        }

        let elaborated_by_id;
        if (values.elaborated_by_id) {
            if (values.elaborated_by_id.id) {
                elaborated_by_id = values.elaborated_by_id.id;
            } else {
                elaborated_by_id = values.elaborated_by_id;
            }
        }

        let called_by_id;
        if (values.called_by_id) {
            if (values.called_by_id.id) {
                called_by_id = values.called_by_id.id;
            } else {
                called_by_id = values.called_by_id;
            }
        }

        let interviewed_by_id;
        if (values.interviewed_by_id) {
            if (values.interviewed_by_id.id) {
                interviewed_by_id = values.interviewed_by_id.id;
            } else {
                interviewed_by_id = values.interviewed_by_id;
            }
        }

        let result_interview;
        if (values.result_interview) {
            if (values.result_interview.value) {
                result_interview = values.result_interview.value;
                if (values.result_interview.value === 'Autorizado' ||
                    values.result_interview.value === 'Favorable' ||
                    values.result_interview.value === 'Novedad' ||
                    values.result_interview.value === 'No Contestó' ||
                    values.result_interview.value === 'No Apto' ||
                    values.result_interview.value === 'No asistió') {
                    if (!this.edit.end_interview) {
                        values.end_interview = formatDate(new Date().toISOString());
                    }
                    if (!this.edit.start_interview && !values.start_interview) {
                        values.start_interview = formatDate(new Date().toISOString());
                    }
                }
            }
        }

        let tested_by_id;
        if (values.tested_by_id) {
            if (values.tested_by_id.id) {
                tested_by_id = values.tested_by_id.id;
            } else {
                tested_by_id = values.tested_by_id;
            }
        }

        let result_test;
        if (values.result_test) {
            if (values.result_test.value) {
                result_test = values.result_test.value;
                if (values.result_test.value) {
                    result_test = values.result_test.value;
                    if (values.result_test.value === 'Autorizado' ||
                        values.result_test.value === 'Favorable' ||
                        values.result_test.value === 'Novedad' ||
                        values.result_test.value === 'No Apto') {
                        if (!this.edit.end_test) {
                            values.end_test = formatDate(new Date().toISOString());
                        }
                        if (!this.edit.start_test && !values.start_test) {
                            values.start_test = formatDate(new Date().toISOString());
                        }
                    }
                }
            }
        }

        let documental_analysis_by_id;
        if (values.documental_analysis_by_id) {
            if (values.documental_analysis_by_id.id) {
                documental_analysis_by_id = values.documental_analysis_by_id.id;
            } else {
                documental_analysis_by_id = values.documental_analysis_by_id;
            }
        }

        let result_documental_analysis;
        if (values.result_documental_analysis) {
            if (values.result_documental_analysis.value) {
                result_documental_analysis = values.result_documental_analysis.value;
                if (values.result_documental_analysis.value) {
                    result_documental_analysis = values.result_documental_analysis.value;
                    if (values.result_documental_analysis.value === 'Autorizado' ||
                        values.result_documental_analysis.value === 'Favorable' ||
                        values.result_documental_analysis.value === 'Novedad' ||
                        values.result_documental_analysis.value === 'Revisado' ||
                        values.result_documental_analysis.value === 'No Apto' ||
                        values.result_documental_analysis.value === 'Sin Documentos') {
                        if (!this.edit.end_documental_analysis) {
                            values.end_documental_analysis = formatDate(new Date().toISOString());
                        }
                        if (!this.edit.start_documental_analysis && !values.start_documental_analysis) {
                            values.start_documental_analysis = formatDate(new Date().toISOString());
                        }
                    }
                }
            }
        }

        let referencing_by_id;
        if (values.referencing_by_id) {
            if (values.referencing_by_id.id) {
                referencing_by_id = values.referencing_by_id.id;
            } else {
                referencing_by_id = values.referencing_by_id;
            }
        }

        let result_referencing;
        if (values.result_referencing) {
            if (values.result_referencing.value) {
                result_referencing = values.result_referencing.value;
                if (values.result_referencing.value) {
                    result_referencing = values.result_referencing.value;
                    if (values.result_referencing.value === 'Autorizado' ||
                        values.result_referencing.value === 'Favorable' ||
                        values.result_referencing.value === 'Novedad' ||
                        values.result_referencing.value === 'No Apto' ||
                        values.result_referencing.value === 'Reingreso' ||
                        values.result_referencing.value === 'Sin documentos') {
                        if (!this.edit.end_referencing) {
                            values.end_referencing = formatDate(new Date().toISOString());
                        }
                        if (!this.edit.start_referencing && !values.start_referencing) {
                            values.start_referencing = formatDate(new Date().toISOString());
                        }
                    }
                }
            }
        }

        let result_background_validation;
        if (values.result_background_validation) {
            if (values.result_background_validation.value) {
                result_background_validation = values.result_background_validation.value;
                if (values.result_background_validation.value) {
                    result_background_validation = values.result_background_validation.value;
                    if (values.result_background_validation.value === 'Autorizado' ||
                        values.result_background_validation.value === 'Favorable' ||
                        values.result_background_validation.value === 'Novedad' ||
                        values.result_background_validation.value === 'No Apto' ||
                        values.result_background_validation.value === 'Reingreso'||
                        values.result_background_validation.value === 'Sin documentos') {
                        if (!this.edit.end_background_validation) {
                            values.end_background_validation = formatDate(new Date().toISOString());
                        }
                        if (!this.edit.start_background_validation && !values.start_background_validation) {
                            values.start_background_validation = formatDate(new Date().toISOString());
                        }
                    }
                }
            }
        }

        let medical_exams_by_id;
        if (values.medical_exams_by_id) {
            if (values.medical_exams_by_id.id) {
                medical_exams_by_id = values.medical_exams_by_id.id;
            } else {
                medical_exams_by_id = values.medical_exams_by_id;
            }
        }

        let result_medical_exams;
        if (values.result_medical_exams) {
            if (values.result_medical_exams.value) {
                result_medical_exams = values.result_medical_exams.value;
                if (values.result_medical_exams.value === 'Autorizado' ||
                    values.result_medical_exams.value === 'Favorable' ||
                    values.result_medical_exams.value === 'Compromiso' ||
                    values.result_medical_exams.value === 'No Apto' ||
                    values.result_medical_exams.value === 'Aplazado' ||
                    values.result_medical_exams.value === 'Candidato en atención' ||
                    values.result_medical_exams.value === 'No ha llegado el examen médico al correo' ||
                    values.result_medical_exams.value === 'Se esta ampliando información' ||
                    values.result_medical_exams.value === 'No asistió' ||
                    values.result_medical_exams.value === 'Pendiente cierre de historia clinica')
                    {
                    if (!this.edit.end_medical_exams) {
                        values.end_medical_exams = formatDate(new Date().toISOString());
                    }
                    if (!this.edit.start_medical_exams && !values.start_medical_exams) {
                        values.start_medical_exams = formatDate(new Date().toISOString());
                    }
                }
            }
        }

        let send_customer_by_id;
        if (values.send_customer_by_id) {
            if (values.send_customer_by_id.id) {
                send_customer_by_id = values.send_customer_by_id.id;
            } else {
                send_customer_by_id = values.send_customer_by_id;
            }
        }

        let result_send_customer;
        if (values.result_send_customer) {
            if (values.result_send_customer.value) {
                result_send_customer = values.result_send_customer.value;
                if (values.result_send_customer.value === 'Autorizado' ||
                    values.result_send_customer.value === 'Favorable' ||
                    values.result_send_customer.value === 'Novedad' ||
                    values.result_send_customer.value === 'No Apto' ||
                    values.result_send_customer.value === 'No asistió') {
                    if (!this.edit.end_send_customer) {
                        values.end_send_customer = formatDate(new Date().toISOString());
                    }
                    if (!this.edit.start_send_customer && !values.start_send_customer) {
                        values.start_send_customer = formatDate(new Date().toISOString());
                    }
                }
            }
        }

        let hire_by_id;
        if (values.hire_by_id) {
            if (values.hire_by_id.id) {
                hire_by_id = values.hire_by_id.id;
            } else {
                hire_by_id = values.hire_by_id;
            }
        }

        let hiring_analyst_id;
        if (values.hiring_analyst_id) {
            if (values.hiring_analyst_id.id) {
                hiring_analyst_id = values.hiring_analyst_id.id;
            } else {
                hiring_analyst_id = values.hiring_analyst_id;
            }
        }
        let manager_send_hiring_sign_by_id;
        if(values.manager_send_hiring_sign_by_id){
            if(values.manager_send_hiring_sign_by_id.id)
                manager_send_hiring_sign_by_id=values.manager_send_hiring_sign_by_id.id;
            else
                manager_send_hiring_sign_by_id=values.manager_send_hiring_sign_by_id;
        }

        let result_hire;
        if (values.result_hire) {
            if (values.result_hire.value) {
                result_hire = values.result_hire.value;
                if (values.result_hire.value === 'Autorizado' ||
                    values.result_hire.value === 'Contratado' ||
                    values.result_hire.value === 'Favorable' ||
                    values.result_hire.value === 'Novedad' ||
                    values.result_hire.value === 'Inejecución' ||
                    values.result_hire.value === 'No contratado' ||
                    values.result_hire.value === 'Desitió' ||
                    values.result_hire.value === 'No Apto') {
                    if (!this.edit.end_hire) {
                        values.end_hire = formatDate(new Date().toISOString());
                    }
                    if (!this.edit.start_hire && !values.start_hire) {
                        values.start_hire = formatDate(new Date().toISOString());
                    }
                }
            }
        }

        let approval_hire_by_id;
        if (values.approval_hire_by_id) {
            if (values.approval_hire_by_id.id) {
                approval_hire_by_id = values.approval_hire_by_id.id;
            } else {
                approval_hire_by_id = values.approval_hire_by_id;
            }
        }

        let verify_hire_by_id;
        if (values.verify_hire_by_id) {
            if (values.verify_hire_by_id.id) {
                verify_hire_by_id = values.verify_hire_by_id.id;
            } else {
                verify_hire_by_id = values.verify_hire_by_id;
            }
        }

        let updated_by_id;
        if (values.updated_by_id) {
            if (values.updated_by_id.id) {
                updated_by_id = values.updated_by_id.id;
            } else {
                updated_by_id = values.updated_by_id;
            }
        }

        let observation_interview = values.observation_interview;
        let observation_personal_familiar = values.observation_personal_familiar;
        let academic_information = values.academic_information;
        let work_experience = values.work_experience;
        let observation_final_concept = values.observation_final_concept;
        let observation_test = values.observation_test;
        let observation_documental_analysis = values.observation_documental_analysis;
        let observation_referencing = values.observation_referencing;
        let observation_background_validation = values.observation_background_validation;
        let observation_medical_exams = values.observation_medical_exams;
        let observation_send_customer = values.observation_send_customer;

        if (this.allinone) {
            if (values.interviewed_by_id) {
                if (values.interviewed_by_id.id) {
                    interviewed_by_id = values.interviewed_by_id.id;
                    recruited_by_id = values.interviewed_by_id.id;
                    elaborated_by_id = values.interviewed_by_id.id;
                    called_by_id = values.interviewed_by_id.id;
                    tested_by_id = values.interviewed_by_id.id;
                    documental_analysis_by_id = values.interviewed_by_id.id;
                    referencing_by_id = values.interviewed_by_id.id;
                    // medical_exams_by_id = values.interviewed_by_id.id;
                    send_customer_by_id = values.interviewed_by_id.id;
                    approval_hire_by_id = values.interviewed_by_id.id;
                    verify_hire_by_id = values.interviewed_by_id.id;
                    updated_by_id = values.interviewed_by_id.id;
                } else {
                    interviewed_by_id = values.interviewed_by_id;
                    recruited_by_id = values.interviewed_by_id;
                    elaborated_by_id = values.interviewed_by_id;
                    called_by_id = values.interviewed_by_id;
                    tested_by_id = values.interviewed_by_id;
                    documental_analysis_by_id = values.interviewed_by_id;
                    referencing_by_id = values.interviewed_by_id;
                    // medical_exams_by_id = values.interviewed_by_id;
                    send_customer_by_id = values.interviewed_by_id;
                    approval_hire_by_id = values.interviewed_by_id;
                    verify_hire_by_id = values.interviewed_by_id;
                    updated_by_id = values.interviewed_by_id;
                }
            }

            if (values.result_interview) {
                if (values.result_interview.value) {
                    result_interview = values.result_interview.value;
                    result_test = values.result_interview.value;
                    result_documental_analysis = values.result_interview.value;
                    result_referencing = values.result_interview.value;
                    // result_medical_exams = values.result_interview.value;
                    result_send_customer = values.result_interview.value;

                    observation_interview = values.observation_interview;
                    observation_test = values.observation_interview;
                    observation_documental_analysis = values.observation_interview;
                    observation_referencing = values.observation_interview;
                    // observation_medical_exams = values.observation_interview;
                    observation_send_customer = values.observation_interview;

                    if (values.result_interview.value === 'Autorizado' ||
                        values.result_interview.value === 'Favorable' ||
                        values.result_interview.value === 'Novedad' ||
                        values.result_interview.value === 'No Apto' ||
                        values.result_interview.value === 'No asistió') {
                        if (!this.edit.end_interview) {
                            values.end_interview = formatDate(new Date().toISOString());
                            values.end_test = formatDate(new Date().toISOString());
                            values.end_documental_analysis = formatDate(new Date().toISOString());
                            values.end_referencing = formatDate(new Date().toISOString());
                            // values.end_medical_exams = formatDate(new Date().toISOString());
                            values.end_send_customer = formatDate(new Date().toISOString());
                        }
                        if (!this.edit.start_interview && !values.start_interview) {
                            values.start_interview = formatDate(new Date().toISOString());
                        }
                    }
                }
            }
        }

        let recruited;
        let recruited_accepted;
        if (!this.edit && this.editPart == 'recruited') {
            recruited = 1;
            recruited_accepted = 0;
        } else {
            if(values.recruited =='')
                recruited='0';
            else
                recruited = values.recruited;
            recruited_accepted = values.recruited_accepted;
        }

        let admission_dates;
        if (values.admission_date == "") {
            admission_dates = null;
        } else {
            admission_dates = formatDate(values.admission_date);
        }
        let date_medical_appointment;
        let date_medical_appointment_result;
        let date_medical_appointment_two;
        let date_medical_appointment_result_two;
        let date_medical_appointment_three;
        let date_medical_appointment_result_three;
        if (this.idRequisition || this.idCitation) {
            param = {
                'read': values.read,
                'requisition_id': Number(this.idRequisition),
                'venue_id': values.venue_id.id,
                'company_id': values.company_id.id,
                'candidate_id': values.candidate_id.id,
                'profile_survey_id': values.profile_survey_id.id,
                'management': values.management.value,
                // 'status': values.status.value,
                'date_citations': (values.date_citations == '') ? null : formatDate(values.date_citations),
                'source': values.source.value,
                'recruited': recruited,
                'recruited_at': (values.recruited_at == '') ? null : formatDate(values.recruited_at),
                'recruited_by_id': recruited_by_id,
                'elaborated_by_id': elaborated_by_id,
                'recruited_accepted': recruited_accepted,

                'interviewed_by_id': interviewed_by_id,
                'observation_interview': observation_interview,
                'observation_personal_familiar': observation_personal_familiar,
                'academic_information': academic_information,
                'work_experience': work_experience,
                'observation_final_concept': observation_final_concept,

                'result_interview': result_interview,
                'start_interview': values.start_interview,
                'end_interview': values.end_interview,
                'emergency_contact': values.emergency_contact,
                'emergency_contact_number': values.emergency_contact_number,

                'called_by_id': called_by_id,
                'time': values.time,
                'observation_citation': values.observation_citation,
                'attended': values.attended,
                'arrival_time': values.arrival_time,
                'start_citation': values.start_citation,
                'end_citation': values.end_citation,

                'tested_by_id': tested_by_id,
                'test': values.test,
                'observation_test': observation_test,
                'result_test': result_test,
                'start_test': values.start_test,
                'end_test': values.end_test,

                'documental_analysis_by_id': documental_analysis_by_id,
                'observation_documental_analysis': observation_documental_analysis,
                'result_documental_analysis': result_documental_analysis,
                'start_documental_analysis': values.start_documental_analysis,
                'end_documental_analysis': values.end_documental_analysis,

                'referencing_by_id': referencing_by_id,
                'observation_referencing': observation_referencing,
                'result_referencing': result_referencing,
                'start_referencing': values.start_referencing,
                'end_referencing': values.end_referencing,


                // 'background_validation_by_id': background_validation_by_id,
                'observation_background_validation': observation_background_validation,
                'result_background_validation': result_background_validation,
                'start_background_validation': values.start_background_validation,
                'end_background_validation': values.end_background_validation,

                'medical_exams_by_id': medical_exams_by_id,
                'observation_medical_exams': observation_medical_exams,
                'result_medical_exams': result_medical_exams,
                'lab_medical_exams': values.lab_medical_exams,
                'start_medical_exams': values.start_medical_exams,
                'end_medical_exams': values.end_medical_exams,

                'send_hiring': values.send_hiring,
                'start_send_hiring': values.start_send_hiring,

                'send_hiring_sign': values.send_hiring_sign,
                'start_send_hiring_sign': values.start_send_hiring_sign,

                'hire_by_id': hire_by_id,
                'hiring_analyst_id': hiring_analyst_id,
                'manager_send_hiring_sign_by_id': manager_send_hiring_sign_by_id,
                'observation_hire': values.observation_hire,
                'result_hire': result_hire,
                'start_hire': values.start_hire,
                'end_hire': values.end_hire,
                'accordance_hire': values.accordance_hire,
                'observation_hire_accordance': values.observation_hire_accordance,
                'cost_center': values.cost_center,
                'admission_date': admission_dates,
                'person_labor': values.person_labor,
                'person_arl': values.person_arl,
                'person_additional_requirements': values.person_additional_requirements,
                'salary_type': values.salary_type,
                'salary': values.salary,

                'second_accordance_hire': values.second_accordance_hire,
                'external_error_hire': values.external_error_hire,
                'internal_error_hire': values.internal_error_hire,
                'treatment_hire': values.treatment_hire,
                'verify_hire_by_id': verify_hire_by_id,
                'approval_hire_by_id': approval_hire_by_id,

                'send_customer_by_id': send_customer_by_id,
                'observation_send_customer': observation_send_customer,
                'result_send_customer': result_send_customer,
                'start_send_customer': values.start_send_customer,
                'end_send_customer': values.end_send_customer,

                'updated_by_id': updated_by_id,
            };
        } else {
            param = {
                'read': values.read,
                'requisition_id': values.requisition_id,
                'venue_id': values.venue_id.id,
                'company_id': values.company_id.id,
                'candidate_id': values.candidate_id.id,
                'profile_survey_id': values.profile_survey_id.id,
                'management': values.management.value,
                'date_citations': (values.date_citations == '') ? null : values.date_citations,
                'source': values.source.value,
                'recruited': values.recruited,
                'recruited_at': (values.recruited_at == '') ? null : values.recruited_at,
                'recruited_by_id': recruited_by_id,
                'elaborated_by_id': elaborated_by_id,

                'interviewed_by_id': interviewed_by_id,
                'observation_interview': observation_interview,
                'observation_personal_familiar': observation_personal_familiar,
                'academic_information': academic_information,
                'work_experience': work_experience,
                'observation_final_concept': observation_final_concept,

                'result_interview': result_interview,
                'start_interview': values.start_interview,
                'end_interview': values.end_interview,
                'emergency_contact': values.emergency_contact,
                'emergency_contact_number': values.emergency_contact_number,

                'called_by_id': called_by_id,
                'time': values.time,
                'observation_citation': values.observation_citation,
                'attended': values.attended,
                'arrival_time': values.arrival_time,
                'start_citation': values.start_citation,
                'end_citation': values.end_citation,

                'tested_by_id': tested_by_id,
                'test': values.test,
                'observation_test': observation_test,
                'result_test': result_test,
                'start_test': values.start_test,
                'end_test': values.end_test,

                'documental_analysis_by_id': documental_analysis_by_id,
                'observation_documental_analysis': observation_documental_analysis,
                'result_documental_analysis': result_documental_analysis,
                'start_documental_analysis': values.start_documental_analysis,
                'end_documental_analysis': values.end_documental_analysis,

                'referencing_by_id': referencing_by_id,
                'observation_referencing': observation_referencing,
                'result_referencing': result_referencing,
                'start_referencing': values.start_referencing,
                'end_referencing': values.end_referencing,

                'medical_exams_by_id': medical_exams_by_id,
                'observation_medical_exams': observation_medical_exams,
                'result_medical_exams': result_medical_exams,
                'lab_medical_exams': values.lab_medical_exams,
                'start_medical_exams': values.start_medical_exams,
                'end_medical_exams': values.end_medical_exams,

                'send_hiring': values.send_hiring,
                'start_send_hiring': values.start_send_hiring,

                'hire_by_id': hire_by_id,
                'hiring_analyst_id': hiring_analyst_id,
                'observation_hire': values.observation_hire,
                'result_hire': result_hire,
                'start_hire': values.start_hire,
                'end_hire': values.end_hire,
                'accordance_hire': values.accordance_hire,
                'observation_hire_accordance': values.observation_hire_accordance,

                'cost_center': values.cost_center,
                'admission_date': admission_dates,
                'person_labor': values.person_labor,
                'person_arl': values.person_arl,
                'person_additional_requirements': values.person_additional_requirements,
                'salary_type': values.salary_type,

                'second_accordance_hire': values.second_accordance_hire,
                'external_error_hire': values.external_error_hire,
                'internal_error_hire': values.internal_error_hire,
                'treatment_hire': values.treatment_hire,
                'verify_hire_by_id': verify_hire_by_id,
                'approval_hire_by_id': approval_hire_by_id,

                'updated_by_id': updated_by_id,
            };
        }
        param['state_backup']=values.state_backup;
        param['observation_backup']=values.observation_backup;
        (values.date_medical_appointment == '') ? date_medical_appointment=null: date_medical_appointment=formatDate(new Date(values.date_medical_appointment).toISOString());
        (values.date_medical_appointment_result == '') ? date_medical_appointment_result=null: date_medical_appointment_result= formatDate(new Date(values.date_medical_appointment_result).toISOString());
        param['date_medical_appointment']= date_medical_appointment;
        param['date_medical_appointment_result']= date_medical_appointment_result;

        (values.date_medical_appointment_two == '') ? date_medical_appointment_two=null: date_medical_appointment_two=formatDate(new Date(values.date_medical_appointment_two).toISOString());
        (values.date_medical_appointment_result_two == '') ? date_medical_appointment_result_two=null: date_medical_appointment_result_two=formatDate(new Date(values.date_medical_appointment_result_two).toISOString());
        param['date_medical_appointment_two']= date_medical_appointment_two;
        param['date_medical_appointment_result_two']= date_medical_appointment_result_two;

        (values.date_medical_appointment_three == '') ? date_medical_appointment_three=null: date_medical_appointment_three=formatDate(new Date(values.date_medical_appointment_three).toISOString());
        (values.date_medical_appointment_result_three == '') ? date_medical_appointment_result_three=null: date_medical_appointment_result_three=formatDate(new Date(values.date_medical_appointment_result_three).toISOString());
        param['date_medical_appointment_three']= date_medical_appointment_three;
        param['date_medical_appointment_result_three']= date_medical_appointment_result_three;

        if (values) {
            if (this.minimum) {
                this.edit = param;
                this.edit.id = Number(this.idCitation);
            }

            const promise = (this.edit) ?
                this.synergocitationService.updateSynergoCitation(this.edit.id, param)
                :
                this.synergocitationService.newSynergoCitation(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        this.close.emit(true);
                        this.form.reset();
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body)).subscribe((res1: string) => {
                        this.notificationsService.growlNotify('error', res1 );
                    });
                    // this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                    //     this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                    //         JSON.parse(error._body).errors.forEach(element => {
                    //             if (element.source) {
                    //                 if (element.source.pointer) {
                    //                     this.translate.get(element.source.pointer).subscribe((res3: string) => {
                    //                         msg = msg + res3 + ', ';
                    //                     });
                    //                 }
                    //             }
                    //         });
                    //         this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                    //         // this.msg.emit( { severity: 'error', summary: 'Error' } );
                    //     });
                    // });
                }
            );
        }
    }

    // public paserRead (values: Attendance) {
    //     console.log('read:' + values.read);
    //     const res = values.read.split(';');

    //     let id = '';
    //     let name1 = '';
    //     let name2 = '';
    //     let name3 = '';
    //     let name4 = '';

    //     if (res[0]) {
    //         id = res[0];
    //     } else {
    //         id = '';
    //     }

    //     if (res[1]) {
    //         name1 = res[1];
    //     } else {
    //         name1 = '';
    //     }

    //     if (res[2]) {
    //         name2 = res[2];
    //     } else {
    //         name2 = '';
    //     }

    //     if (res[3]) {
    //         name3 = res[3];
    //     } else {
    //         name3 = '';
    //     }

    //     if (res[4]) {
    //         name4 = res[4];
    //     } else {
    //         name4 = '';
    //     }

    //     this.identification_number.setValue(id);
    //     this.name.setValue(name3 + ' ' + name4 + ' ' + name1 + ' ' + name2);

    //     this.management.setValue('natural market');
    // }

    public selectedCompany(values) {
        this.profile_survey_id.setValue('');
        if (values.customer_guide) {
            this.customer_guide_id = values.customer_guide.id;
        }
    }

    // public selectedCandidate(values) {
    //     this.identification_number.setValue(values.identification_number);
    //     this.identification_number.disable();
    //     this.name.setValue(values.name);
    //     this.name.disable();
    //     this.email.setValue(values.email);
    //     this.email.disable();
    //     this.phone.setValue(values.phone);
    //     this.phone.disable();
    //     this.mobile.setValue(values.mobile);
    //     this.mobile.disable();
    // }

    public showNewCandidateDialog() {
        // this.identification_number.setValue('');
        // this.identification_number.enable();
        // this.name.setValue('');
        // this.name.enable();
        // this.email.setValue('');
        // this.email.enable();
        // this.phone.setValue('');
        // this.phone.enable();
        // this.mobile.setValue('');
        // this.mobile.enable();
        this.modViewDialog = true;
    }


    public showSpeechTextDialog() {
        this.modViewSpeechTextDialog = true;
    }

    public gotoProfileSurvey(values) {
        window.open('/pages/profile-survey?profile_survey=' + values.profile_survey_id.id) + '?token=' + localStorage.getItem('token');
        return (false);
    }

    public getRequisitions(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.requisitionService.getRequisition(1, 1, undefined, query, filters).toPromise().then(
            response => {
                this.requisitions = response.json().data;
                this.venue_id.setValue(this.requisitions[0].venue);
                this.profile_survey_id.setValue(this.requisitions[0].profile_survey);
                this.company_id.setValue(this.requisitions[0].company);
            },
            error => {
                // this.msgs = [];
                // this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public getSynergoCitations(query?: string, filtersReceived?: any[]) {
        const filters = [];
        if (filtersReceived) {
            filtersReceived.forEach(element => {
                if (element.value) {
                    filters.push({'key': element.key, 'value': element.value});
                }
            });
        }

        this.synergocitationService.getSynergoCitation(1, 1, undefined, query, filters).toPromise().then(
            response => {
                const citations = response.json().data;
                this.read.setValue(citations[0].read);
                this.venue_id.setValue(citations[0].venue_id);
                this.company_id.setValue(citations[0].company_id);
                this.candidate_id.setValue(citations[0].candidate_id);
                this.profile_survey_id.setValue(citations[0].profile_survey_id);
                this.management.setValue(citations[0].management);
                // this.status.setValue(citations[0].status);
                this.date_citations.setValue(new Date(citations[0].date_citations));
                this.source.setValue(citations[0].source);
                this.recruited_by_id.setValue(citations[0].recruited_by_id);
                // this.elaborated_by_id.setValue(citations[0].elaborated_by_id);
                this.observation_interview.setValue(citations[0].observation_interview);
                this.observation_personal_familiar.setValue(citations[0].observation_personal_familiar);
                this.observation_final_concept.setValue(citations[0].observation_final_concept);
                this.called_by_id.setValue(citations[0].called_by_id);
                // this.time.setValue(citations[0].time);
                this.observation_citation.setValue(citations[0].observation_citation);
                this.attended.setValue(citations[0].attended);
                // this.arrival_time.setValue(citations[0].arrival_time);
                if (citations[0].start_citation) {
                    this.start_citation.setValue(new Date(citations[0].start_citation));
                }

                if (citations[0].end_citation) {
                    this.end_citation.setValue(new Date(citations[0].end_citation));
                }

                this.interviewed_by_id.setValue(citations[0].interviewed_by);
                this.observation_interview.setValue(citations[0].observation_interview);
                this.observation_personal_familiar.setValue(citations[0].observation_personal_familiar);
                this.academic_information.setValue(citations[0].academic_information);
                this.work_experience.setValue(citations[0].work_experience);
                this.observation_final_concept.setValue(citations[0].observation_final_concept);

                this.result_interview.setValue(citations[0].result_interview);
                if (citations[0].start_interview) {
                    this.start_interview.setValue(new Date(citations[0].start_interview));
                }

                if (citations[0].end_interview) {
                    this.end_interview.setValue(new Date(citations[0].end_interview));
                }

                this.send_customer_by_id.setValue(citations[0].send_customer_by);
                this.observation_send_customer.setValue(citations[0].observation_send_customer);
                this.result_send_customer.setValue(citations[0].result_send_customer);
                if (citations[0].start_send_customer) {
                    this.start_send_customer.setValue(new Date(citations[0].start_send_customer));
                }

                if (citations[0].end_send_customer) {
                    this.end_send_customer.setValue(new Date(citations[0].end_send_customer));
                }

                this.tested_by_id.setValue(citations[0].tested_by);
                this.test.setValue(citations[0].test);
                this.observation_test.setValue(citations[0].observation_test);
                this.result_test.setValue(citations[0].result_test);
                if (citations[0].start_test) {
                    this.start_test.setValue(new Date(citations[0].start_test));
                }

                if (citations[0].end_test) {
                    this.end_test.setValue(new Date(citations[0].end_test));
                }

                this.documental_analysis_by_id.setValue(citations[0].documental_analysis_by);
                this.observation_documental_analysis.setValue(citations[0].observation_documental_analysis);
                this.result_documental_analysis.setValue(citations[0].result_documental_analysis);
                if (citations[0].start_documental_analysis) {
                    this.start_documental_analysis.setValue(new Date(citations[0].start_documental_analysis));
                }

                if (citations[0].end_documental_analysis) {
                    this.end_documental_analysis.setValue(new Date(citations[0].end_documental_analysis));
                }

                this.referencing_by_id.setValue(citations[0].referencing_by);
                this.observation_referencing.setValue(citations[0].observation_referencing);
                this.result_referencing.setValue(citations[0].result_referencing);
                if (citations[0].start_referencing) {
                    this.start_referencing.setValue(new Date(citations[0].start_referencing));
                }

                if (citations[0].end_referencing) {
                    this.end_referencing.setValue(new Date(citations[0].end_referencing));
                }

                this.background_validation_by_id.setValue(citations[0].background_validation_by);
                this.observation_background_validation.setValue(citations[0].observation_background_validation);
                this.result_background_validation.setValue(citations[0].result_background_validation);
                if (citations[0].start_background_validation) {
                    this.start_background_validation.setValue(new Date(citations[0].start_background_validation));
                }

                if (citations[0].end_background_validation) {
                    this.end_background_validation.setValue(new Date(citations[0].end_background_validation));
                }

                this.medical_exams_by_id.setValue(citations[0].medical_exams_by);
                this.observation_medical_exams.setValue(citations[0].observation_medical_exams);
                this.result_medical_exams.setValue(citations[0].result_medical_exams);
                this.lab_medical_exams.setValue(citations[0].lab_medical_exams);
                if (citations[0].start_medical_exams) {
                    this.start_medical_exams.setValue(new Date(citations[0].start_medical_exams));
                }

                if (citations[0].end_medical_exams) {
                    this.end_medical_exams.setValue(new Date(citations[0].end_medical_exams));
                }

                this.send_hiring.setValue(citations[0].send_hiring);
                if (citations[0].start_send_hiring) {
                    this.start_send_hiring.setValue(new Date(citations[0].start_send_hiring));
                }

                this.send_hiring_sign.setValue(citations[0].send_hiring_sign);
                if (citations[0].start_send_hiring_sign) {
                    this.start_send_hiring_sign.setValue(new Date(citations[0].start_send_hiring_sign));
                }

                this.hire_by_id.setValue(citations[0].hire_by_id);
                this.hiring_analyst_id.setValue(citations[0].hiring_analyst_id);
                this.manager_send_hiring_sign_by_id.setValue(citations[0].manager_send_hiring_sign_by_id);
                this.observation_hire.setValue(citations[0].observation_hire);
                this.result_hire.setValue(citations[0].result_hire);
                if (citations[0].start_hire) {
                    this.start_hire.setValue(new Date(citations[0].start_hire));
                }

                this.cost_center.setValue(citations[0].cost_center);
                this.admission_date.setValue(citations[0].admission_date);
                this.person_labor.setValue(citations[0].person_labor);
                this.person_arl.setValue(citations[0].person_arl);
                this.person_additional_requirements.setValue(citations[0].person_additional_requirements);
                this.salary_type.setValue(citations[0].salary_type);

                if (citations[0].end_hire) {
                    this.end_hire.setValue(new Date(citations[0].end_hire));
                }

                this.accordance_hire.setValue(citations[0].accordance_hire);
                this.observation_hire_accordance.setValue(citations[0].observation_hire_accordance);

                this.second_accordance_hire.setValue(citations[0].second_accordance_hire);
                this.external_error_hire.setValue(citations[0].external_error_hire);
                this.internal_error_hire.setValue(citations[0].internal_error_hire);
                this.treatment_hire.setValue(citations[0].treatment_hire);
                this.verify_hire_by_id.setValue(citations[0].verify_hire_by_id);
                this.approval_hire_by_id.setValue(citations[0].approval_hire_by_id);

                // this.updated_by_id.setValue(citations[0].updated_by);
                this.requisition_id.setValue(citations[0].requisition_id);
            },
            error => {
                // this.msgs = [];
                // this.msgs.push( { severity: 'error', summary: 'error' } );
            }
        );
    }

    public showResultNewCandidate(msg) {
        this.messages = [];
        this.messages.push(msg);

    }

    public getNewCandidate(candidate) {
        console.log (candidate);
        this.modViewDialog = false;
        if (candidate) {
            if (candidate.id) {
                this.new_candidate_id = candidate.id;
                this.candidate_id.setValue(candidate);
            }
        }
    }

    public hasPermission(permission) {
        return this.hasPermissionService.hasPermission(permission);
    }
    public onUploadFileTest(event: any) {
        this.uploadedFileTest = [];
        for (const file of event.srcElement.files) {
            this.uploadedFileTest.push(file);
        }
        if (event.target.files && event.target.files[0]) {
            const reader = new FileReader();
            reader.onload = () => {
              this.prewiewFileTest = reader.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    }

    public updateFileTest(event: any) {
        this.uploadedFileTest = [];
        for (const file of event.files) {
            this.uploadedFileTest.push(file);
        }

        this.promiseFileTest = this.uploadFilesService.updateFileTest(this.uploadedFileTest, this.edit.id).toPromise().then(
            response => {
                this.translate.get('saved').subscribe((res: string) => {
                    this.msgs = [];
                    this.msgs.push( { severity: 'success', summary: res  } );
                });
                // this.getProfile();
                // this.avatar = this.prewiewFileTest;
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    public gotoFileTest() {
      window.open(this.apiUrl + '/citations/' + this.edit.id + '/file-test' + '?token=' + localStorage.getItem('token'), '_blank');
    }

    public downloadFileTest() {
        this.promiseFileTest = this.uploadFilesService.getFileTest(this.edit.id).toPromise().then(
            response => {
            },
            error => {
                let errorMsg = '';
                errorMsg = 'Error';
                this.msgs = [];
                this.msgs.push( { severity: 'error', summary: errorMsg  } );
            }
         );
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }

    public checkOtherValidation (values) {
        let check = false;
        if (values) {
            if (values.candidate_id) {
                if (values.candidate_id.id) {
                    check = true;
                } else {
                    return false;
                }
            }
        }
        return check;
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/synergo/synergo-citations/synergo-new-citation/synergo-new-citation.component.ts